import { SHAPE_KINDS } from '../../constants/shapes'
import type { ShapeKind } from '../../constants/shapes'
import { usePaintStore } from '../../state/paintStore'
import './ShapeKindPicker.css'

function ShapeGlyph({ kind }: { kind: ShapeKind }) {
  if (kind === 'rectangle') {
    return (
      <svg viewBox="0 0 64 48" width="72" height="54" aria-hidden>
        <rect x="6" y="6" width="52" height="36" fill="none" stroke="#000" strokeWidth="4" />
      </svg>
    )
  }
  if (kind === 'ellipse') {
    return (
      <svg viewBox="0 0 64 48" width="72" height="54" aria-hidden>
        <ellipse cx="32" cy="24" rx="26" ry="18" fill="none" stroke="#000" strokeWidth="4" />
      </svg>
    )
  }
  return (
    <svg viewBox="0 0 64 48" width="72" height="54" aria-hidden>
      <polygon points="32,6 58,42 6,42" fill="none" stroke="#000" strokeWidth="4" />
    </svg>
  )
}

export function ShapeKindPicker() {
  const shapeKind = usePaintStore((s) => s.shapeKind)
  const setShapeKind = usePaintStore((s) => s.setShapeKind)

  return (
    <section className="shape-kind-picker" aria-label="Shape kind">
      {SHAPE_KINDS.map((s) => (
        <button
          key={s.id}
          type="button"
          className={`shape-kind-option${shapeKind.id === s.id ? ' is-active' : ''}`}
          onClick={() => setShapeKind(s.id)}
          aria-label={`${s.label} — ${s.requiredPoints} taps`}
          aria-pressed={shapeKind.id === s.id}
        >
          <ShapeGlyph kind={s.id} />
          <span className="shape-kind-label">{s.label}</span>
          <span className="shape-kind-hint">{s.requiredPoints} taps</span>
        </button>
      ))}
    </section>
  )
}
